module.exports = __webpack_public_path__ + "media/images/mamari/wowma/btn-apply-yellow-7df3f9a5abdcdce4263d85b9c4c91f06.png";